<template>
  <a-descriptions size="small" title="门店"></a-descriptions>
  <a-row :gutter="24" type="flex" v-if="visitData.today">
    <a-col v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }" style="margin-bottom: 24px">
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '20px 24px 8px 24px' }">
        <field-big
          label="今日门店收款/付款客人数量："
          :value="`${numeral(visitData.today.cz_price).format('0,0')}元/${
            visitData.today.cz_customer
          }人`"
        />
        <field
          label="昨日门店收款/付款客人数量："
          :value="`${numeral(visitData.yesterday.cz_price).format('0,0')}元/${
            visitData.yesterday.cz_customer
          }人`"
        />
        <a-divider style="margin-bottom: 8px; margin-top: 8px" />
        <field
          label="本月门店收款/付款客人数量："
          :value="`${numeral(visitData.month.cz_price).format('0,0')}元/${
            visitData.month.cz_customer
          }人`"
        />
        <field
          label="上月门店收款/付款客人数量："
          :value="`${numeral(visitData.last_month.cz_price).format('0,0')}元/${
            visitData.last_month.cz_customer
          }人`"
        />
      </a-card>
    </a-col>
    <a-col v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }" style="margin-bottom: 24px">
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '20px 24px 8px 24px' }">
        <field-big
          label="今日门店耗单/耗单客人数量："
          :value="`${numeral(visitData.today.used_price).format('0,0')}元/${
            visitData.today.used_customer
          }人`"
        />
        <field
          label="昨日门店耗单/耗单客人数量："
          :value="`${numeral(visitData.yesterday.used_price).format('0,0')}元/${
            visitData.yesterday.used_customer
          }人`"
        />
        <a-divider style="margin-bottom: 8px; margin-top: 8px" />
        <field
          label="本月门店耗单/耗单客人数量："
          :value="`${numeral(visitData.month.used_price).format('0,0')}元/${
            visitData.month.used_customer
          }人`"
        />
        <field
          label="上月门店耗单/耗单客人数量："
          :value="`${numeral(visitData.last_month.used_price).format('0,0')}元/${
            visitData.last_month.used_customer
          }人`"
        />
      </a-card>
    </a-col>
    <a-col v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }" style="margin-bottom: 24px">
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '20px 24px 8px 24px' }">
        <field-big
          label="本月收款目标"
          :value="`${numeral(visitData.month_cz_price_target).format('0,0')}元`"
        />
        <field
          label="上年同期收款"
          :value="`${numeral(visitData.last_year_same_period.cz_price).format('0,0')}元`"
        />
        <trend flag="up" style="margin-right: 16px" v-if="visitData.month_cz_price_increase >= 0">
          目标同比增长
          <span class="trendText">{{ visitData.month_cz_price_increase }}%</span>
        </trend>
        <trend flag="down" v-if="visitData.month_cz_price_increase < 0">
          目标同比下降
          <span class="trendText">{{ 0 - Number(visitData.month_cz_price_increase) }}%</span>
        </trend>
        <a-divider style="margin-bottom: 8px; margin-top: 8px" />
        <field-big
          label="本年累计收款"
          :value="`${numeral(visitData.year.cz_price).format('0,0')}元`"
        />
      </a-card>
    </a-col>
    <a-col v-bind="{ xs: 24, sm: 12, md: 12, lg: 12, xl: 6 }" style="margin-bottom: 24px">
      <a-card :bordered="false" :loading="loading" :body-style="{ padding: '20px 24px 8px 24px' }">
        <field-big
          label="本月耗单目标"
          :value="`${numeral(visitData.month_used_price_target).format('0,0')}元`"
        />
        <field
          label="上年同期耗单"
          :value="`${numeral(visitData.last_year_same_period.used_price).format('0,0')}元`"
        />
        <trend flag="up" style="margin-right: 16px" v-if="visitData.month_used_price_increase >= 0">
          目标同比增长
          <span class="trendText">{{ visitData.month_used_price_increase }}%</span>
        </trend>
        <trend flag="down" v-if="visitData.month_used_price_increase < 0">
          目标同比下降
          <span class="trendText">{{ 0 - Number(visitData.month_used_price_increase) }}%</span>
        </trend>
        <a-divider style="margin-bottom: 8px; margin-top: 8px" />
        <field-big
          label="本年累计耗单"
          :value="`${numeral(visitData.year.used_price).format('0,0')}元`"
        />
      </a-card>
    </a-col>
  </a-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Field, FieldBig } from './charts';
import Trend from './trend/index.vue';
import numeral from 'numeral';

export default defineComponent({
  name: 'ShopDeskTop',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    visitData: {
      type: [Array, Object],
      required: true,
    },
  },
  setup() {
    return {
      numeral,
    };
  },
  components: {
    Field,
    Trend,
    FieldBig,
  },
});
</script>
